import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function blogSlider() {
	const section = document.querySelector('.section-blog');
	if (!section) return;

	const container = section.querySelector('.section-blog__slider');
	if (!container) return;

	const prevBtn = section.querySelector('.section-blog__nav-prev');
	const nextBtn = section.querySelector('.section-blog__nav-next');

	new Swiper(container, {
		modules: [Navigation, Pagination],
		slidesPerView: 'auto',
		spaceBetween: 20,
		speed: 500,
		grabCursor: true,
		navigation: {
			prevEl: prevBtn,
			nextEl: nextBtn,
		},
		pagination: {
			el: '.section-blog .swiper-pagination',
			clickable: true,
		},
	});
}
